import React, { useState, useEffect } from "react";
import useApi from "../../hooks/useApi";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { CSVLink } from "react-csv";
import Table from "react-bootstrap/Table";
import useApp from "../../hooks/useApp";
import DatePicker from "react-datepicker";

export const ClientBusinessReport = () => {
  const { api, auth } = useApi();
  const { convertCurrency } = useApp();
  const [dropDowns, setDropDowns] = useState({});
  const [startDate] = useState(new Date());
  const [filter, setFilter] = useState({ year: startDate });
  const [report, setReport] = useState([]);
  const [reportGroup, setReportGroup] = useState({});

  const getDropDowns = async (models) => {
    try {
      const { data } = await api.list(`/dropdowns`, models);
      setDropDowns({ ...dropDowns, ...data });
    } catch (error) {
      console.error(error);
    }
  };

  const onGenerateReport = async (e) => {
    e.preventDefault();
    try {
      const filterData = {
        ...filter,
        ClientId: filter?.ClientId?.value || "",
        status: filter?.status?.value || "",
        PolicyTypeId: filter?.PolicyTypeId?.value || "",
        ProductId: filter?.ProductId?.value || "",
        policyCurrency: filter?.policyCurrency?.value || "",
      };
      const url = `/reports/client-business`;
      const { data } = await api.getAll(url, filterData, true);

      let dataGroupByCurrency = {};
      data.forEach((element) => {
        if (!element.policyCurrency) {
          element.policyCurrency = "GHS";
        }
        if (dataGroupByCurrency[element?.policyCurrency]) {
          dataGroupByCurrency[element?.policyCurrency].push(
            Number(element?.premium || 0)
          );
        } else {
          dataGroupByCurrency[element?.policyCurrency] = [];
          dataGroupByCurrency[element?.policyCurrency].push(
            Number(element?.premium || 0)
          );
        }
      });

      setReportGroup(dataGroupByCurrency);
      setReport(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDropDowns(["client", "policyType"]);
  }, [auth]);

  useEffect(() => {
    if (dropDowns && filter) {
      setFilter({
        ...filter,
        ClientId:
          dropDowns?.client?.find(
            (client) => client.value === filter.ClientId
          ) || "",
      });
    }
  }, [dropDowns]);

  useEffect(() => {
    const productDropDown = async () => {
      try {
        await getDropDowns([
          {
            product: {
              PolicyTypeId: filter.PolicyTypeId.value,
            },
          },
        ]);
      } catch (error) {}
    };

    if (filter.PolicyTypeId) {
      setFilter({ ...filter, ProductId: "" });
      productDropDown();
    }
  }, [filter.PolicyTypeId]);

  const headers = [
    { label: "Client", key: "Client.name" },
    { label: "Policy Type", key: "PolicyType.name" },
    { label: "Product", key: "Product.name" },
    { label: "Insurer", key: "Company.name" },
    { label: "Effective Date", key: "effectiveDate" },
    { label: "Expiry Date", key: "expires" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Policy Title", key: "title" },
    { label: "Premium", key: "premium" },
    { label: "Currency", key: "policyCurrency" },
    { label: "Status", key: "status" },
  ];

  const csvReport = {
    data: report,
    headers: headers,
    filename: "client_business_report.csv",
  };

  return (
    <>
      <Form
        onSubmit={onGenerateReport}
        autoComplete="off"
        id="filterForm"
        className="mb-3"
      >
        <div className="card h-100">
          <fieldset>
            <div className="card-body">
              <div>
                <Row className="mb-3">
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Year</Form.Label>
                      <DatePicker
                        dateFormat="yyyy"
                        showYearPicker
                        showPopperArrow={false}
                        id="effective-date-year"
                        className="form-control"
                        selected={filter?.year || ""}
                        onChange={(date) =>
                          setFilter({ ...filter, year: date })
                        }
                        isClearable
                        placeholderText=""
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Quarter</Form.Label>
                      <DatePicker
                        renderCustomHeader={({ date }) => (
                          <div
                            style={{
                              margin: 10,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          ></div>
                        )}
                        dateFormat="QQQ"
                        showQuarterYearPicker
                        showPopperArrow={false}
                        id="effective-date-quarter"
                        className="form-control"
                        selected={filter?.quarter || ""}
                        onChange={(date) =>
                          setFilter({ ...filter, quarter: date })
                        }
                        isClearable
                        placeholderText=""
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Month</Form.Label>
                      <DatePicker
                        renderCustomHeader={({ date }) => (
                          <div
                            style={{
                              margin: 10,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          ></div>
                        )}
                        dateFormat="MMMM"
                        showMonthYearPicker
                        showFullMonthYearPicker
                        showPopperArrow={false}
                        id="effective-date-month"
                        className="form-control"
                        selected={filter?.month || ""}
                        onChange={(date) =>
                          setFilter({ ...filter, month: date })
                        }
                        isClearable
                        placeholderText=""
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">
                        Policy Currency
                      </Form.Label>
                      <Select
                        id="currency"
                        options={[
                          { label: "GHS", value: "GHS" },
                          { label: "USD", value: "USD" },
                        ]}
                        onChange={(selectedOption) =>
                          setFilter({
                            ...filter,
                            policyCurrency: selectedOption,
                          })
                        }
                        value={filter?.policyCurrency || "GHS"}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Client</Form.Label>
                      <Select
                        id="currency"
                        options={
                          dropDowns && dropDowns["client"]
                            ? dropDowns["client"]
                            : []
                        }
                        onChange={(selectedOption) =>
                          setFilter({
                            ...filter,
                            ClientId: selectedOption,
                          })
                        }
                        value={filter?.ClientId || ""}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Status</Form.Label>
                      <Select
                        id="status"
                        options={[
                          { label: "Awaiting Renewal", value: "awaiting" },
                          { label: "Terminated", value: "terminated" },
                          { label: "Active", value: "active" },
                          { label: "Expiring", value: "expiring" },
                          { label: "Expired", value: "expired" },
                          { label: "Active/Renewed", value: "renewal" },
                        ]}
                        onChange={(selectedOption) =>
                          setFilter({
                            ...filter,
                            status: selectedOption,
                          })
                        }
                        value={filter?.status || ""}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">
                        Policy Type
                      </Form.Label>
                      <Select
                        id="policyType"
                        options={
                          dropDowns && dropDowns["policyType"]
                            ? dropDowns["policyType"]
                            : []
                        }
                        onChange={(selectedOption) =>
                          setFilter({
                            ...filter,
                            PolicyTypeId: selectedOption,
                          })
                        }
                        value={filter?.PolicyTypeId || ""}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Product</Form.Label>
                      <Select
                        id="product"
                        options={
                          dropDowns && dropDowns["product"]
                            ? dropDowns["product"]
                            : []
                        }
                        onChange={(selectedOption) =>
                          setFilter({
                            ...filter,
                            ProductId: selectedOption,
                          })
                        }
                        value={filter?.ProductId || ""}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </div>
          </fieldset>
          <div className="card-footer">
            <div className="d-flex justify-content-between">
              <button className={"btn btn-primary"} type="submit">
                Generate Report
              </button>
            </div>
          </div>
        </div>
      </Form>
      {report?.length > 0 && (
        <>
          {Object.keys(reportGroup)?.length > 0 && (
            <div className="card h-100 mb-3">
              <div className="card-header">
                <h1>Summary - Premium Paid</h1>
              </div>
              <div className="card-body">
                <Row>
                  {Object.keys(reportGroup).map((currencyGroup) => (
                    <Col
                      sm={12}
                      md={6}
                      className=" mb-2 text-black"
                      key={currencyGroup}
                    >
                      <h1 className="text-primary">{currencyGroup}</h1>
                      <hr />
                      <p>Count: {reportGroup[currencyGroup].length}</p>
                      <p>
                        Total Value:{" "}
                        {convertCurrency(
                          reportGroup[currencyGroup].reduce((a, b) => a + b),
                          currencyGroup
                        )}
                      </p>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          )}
          <div className="card h-100">
            <div className="card-header">
              <h1>Report</h1>
            </div>
            <div className="card-body">
              <CSVLink {...csvReport}>Export to CSV</CSVLink>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <td>Client</td>
                    <td>Policy Type</td>
                    <td>Product</td>
                    <td>Insurer</td>
                    <td>Effective Date</td>
                    <td>Expiry Date</td>
                    <td>Policy Number</td>
                    <td>Policy Title</td>
                    <td align="right">Premium</td>
                    <td>Status</td>
                  </tr>
                </thead>
                <tbody>
                  {report.map((element) => (
                    <tr key={element.id}>
                      <td>{element?.Client?.name}</td>
                      <td>{element?.PolicyType?.name}</td>
                      <td>{element?.Product?.name}</td>
                      <td>{element?.Company?.name}</td>
                      <td>{element?.effectiveDate}</td>
                      <td>{element?.expires}</td>
                      <td>{element?.policyNumber}</td>
                      <td>{element?.title}</td>
                      <td align="right">
                        {convertCurrency(
                          element?.premium || 0,
                          element?.policyCurrency || ""
                        )}
                      </td>
                      <td>{element?.status}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </>
      )}
    </>
  );
};
